import { useFlowDraftStore, useNodeInsertStore } from '@/store'

export function useNodeDataInsert() {
  const { node, saveNode } = useNodeInsertStore()
  const { insertNode } = useFlowDraftStore()

  const insert = (options: {
    target: string
    source: string
    sourceHandleId?: string | null
  }) => {
    if (node) {
      insertNode({
        ...node,
        ...options,
      })
    }
  }

  return {
    save: saveNode,
    insert,
  }
}
